import colors from '~/style/theme/colors'

export const PROCESS_GRID_CONTENT = [
  {
    name: "submit",
    iconName: "icon_file",
    text: "Snap a picture of your ticket, or use the app to search NYC’s servers for tickets associated with your license plate.",
    color: colors.primary
  },
  {
    name: "review",
    iconName: "search-1",
    text: "Submit any evidence right in the app. Our team will inspect your ticket for errors.",
    color: colors.primary
  },
  {
    name: "dispute",
    iconName: "libra",
    text: "You’re all done! Our team will handle every aspect of your dispute, and update you every step of the way.",
    color: colors.primary
  },
  {
    name: "save",
    iconName: "dollar",
    text: "Every ticket is covered by our risk-free guarantee: We don’t charge you unless your ticket is totally dismissed! Our fee is just 50% of the fine.",
    color: colors.primary
  }
]


export const BENEFITS_GRID_CONTENT = [
  {
    name: "submit",
    iconName: "icon_file",
    text: "Upload the details of your ticket.",
    color: colors.error,
  },
  {
    name: "attorney",
    iconName: "libra",
    text: "Hire an attorney to work on your case and represent you.",
    color: colors.error,
  },
  {
    name: "easy process",
    iconName: "star",
    text: "Pay one up-front fee for your dispute, and stay up to date every step of the way.",
    color: colors.error,
  }
]

export const GRID_THEME = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // columns
    gutterWidth: 1, // rem
    outerMargin: 0, // rem
    mediaQuery: "only screen",
    // container: {
    //   sm: 38,
    //   md: 59,
    //   lg: 61
    // },
    breakpoints: {
      xs: 0,
      sm: 20,
      md: 40,
      lg: 50
    }
  }
}

export const PROCESS_COLUMNS = {
  item: {
    xs: 12,
    sm: 12,
    md: 3,
    xl: 3
  }
}

export const BENEFITS_COLUMNS = {
  item: {
    xs: 12,
    sm: 12,
    md: 4,
    xl: 4
  }
}

export const PROCESS_ICON_STYLE = {
  color: colors.primary,
  height: "20px",
  width: "20px"
}

export const BENEFITS_ICON_STYLE = {
  color: colors.error,
  height: "20px",
  width: "20px"
}
